import * as Konvaw from 'konva';
const Konva: typeof Konvaw.default = <any>Konvaw;
interface label {
    name: string;
    r: number;
    x: number;
    y: number;
    speed: number;
    styleIndex: number;
};
const styles = [
    {
        fillLinearGradientColorStops: [0, 'rgba(46,230,168,0.02)', 1, 'rgba(46,230,168,0.35)'],
        stroke: 'rgba(46,230,168,0.4)',
        textColor: 'rgba(46,230,168,1)',
        opacity: 1
    },
    {
        fillLinearGradientColorStops: [0, 'rgba(33,133,240,0.05)', 0.98, 'rgba(33,133,240,1)'],
        stroke: 'rgba(3,140,251,1)',
        textColor: '#038CFB',
        opacity: 0.25
    },
]
export default class Bubble {
    private data: Array<label> = [];
    private groups: Array<any> = [];
    private animationList: Array<any> = [];
    private stage: any;
    private layer: any;
    private width = 0;
    private height = 0;
    private anim: any = null;

    constructor(dom: any) {

        this.width = dom.clientWidth;
        this.height = dom.clientHeight;

        this.stage = new Konva.Stage({
            container: dom,
            width: this.width,
            height: this.height
        });
        this.layer = new Konva.Layer();
        this.stage.add(this.layer);

    }
    setData(data: any) {

        this.data = data.map((item: any, index: number) => {
            const x = Math.floor(Math.random() * (-item.r * 0.8 + this.width + item.r * 0.2));
            const y = this.getRandomY(item.r);;
            let speed = 0.5 + Math.random();

            return {
                name: item.name,
                r: item.r,
                x: x,
                y: y,
                speed,
                styleIndex: index % 2 == 0 ? 0 : 1
            };
        });
        this.createCircleLabel();
    }
    createCircleLabel() {

        this.data.forEach(item => {
            const group: any = new Konva.Group({
                x: item.x,
                y: item.y,
                width: item.r * 2,
                height: item.r * 2,
                draggable: true
            });
            group.__xOff = item.x;
            group.__distanceBetweenWaves = 50 + Math.random() * 40;
            group.__speed = item.speed;
            group.__y = item.y
            const circle = new Konva.Circle({
                x: 0,
                y: 0,
                radius: item.r,
                fillLinearGradientStartPoint: { x: 0, y: -item.r },
                fillLinearGradientEndPoint: { x: 0, y: item.r },
                fillLinearGradientColorStops: styles[item.styleIndex].fillLinearGradientColorStops,
                stroke: styles[item.styleIndex].stroke,
                strokeWidth: 0.5,
                opacity: styles[item.styleIndex].opacity
            });

            const text = new Konva.Text({
                fontFamily: 'PingFangSC-Regular',
                x: 0 - item.r,
                y: 0 - item.r,
                fontSize: 14,
                text: item.name,
                letterSpacing: 0.78,
                width: item.r * 2,
                height: item.r * 2,
                fill: styles[item.styleIndex].textColor,
                align: "center",
                verticalAlign: "middle"
            });


            group.add(circle);
            group.add(text);

            this.layer.add(group);
            this.groups.push(group);
        });
        // this.groups.sort((a, b) => {
        //     return b.__speed - a.__speed;
        // });
        this.animation();

    }
    animation() {
        const maxLen = 9;
        this.animationList = this.groups.splice(0, maxLen);
        this.anim = new Konva.Animation((frame: any) => {
            for (let index = 0; index < this.animationList.length; index++) {
                const group = this.animationList[index];

                let x = Math.sin(group.__y / group.__distanceBetweenWaves) * 50 + group.__xOff;

                if (group.__y < 0) {
                    if (group.__recycle) {
                        if (group.__y < 0 - group.height()) {
                            group.__y = this.height + group.height();
                            this.animationList.splice(index, 1);
                            this.groups.push(group);
                            index--;
                            group.__recycle = false;
                        }
                    } else {
                        group.__recycle = true;
                        const shift = this.groups.shift();
                        this.animationList.push(shift)
                    }

                    // if (group.__y < 0 - group.height()) {
                    //     group.__y = this.height + group.height();
                    //     this.animationList.splice(index, 1);
                    //     this.groups.push(group);
                    //     const shift = this.groups.shift();
                    //     this.animationList.push(shift)
                    //     index--;
                    // } else {

                    // }


                }
                group.__y -= group.__speed;
                group.x(x);
                group.y(group.__y);
                // group.__xOff = x;
                group.draw();


            }

        }, this.layer);

        this.anim.start();
        // setInterval(() => {
        //     console.log(this.animationList.length);
        // }, 1000)
    }
    getRandomY(l: number) {
        return Math.floor(this.height + this.height / 2 * Math.random() + l);
    }
    destroy() {
        this.anim.stop();
        this.stage.destroy();
    }
}